import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { translate } from '@jsverse/transloco';
import { map, Observable } from 'rxjs';
import {
  ConfirmationDialogComponent,
  IConfirmationDialogData,
  IConfirmationDialogResult,
} from '../components/confirmation-dialog/confirmation-dialog.component';

@Injectable({ providedIn: 'root' })
export class ConfirmationService {
  private readonly dialog = inject(MatDialog);

  confirm(
    confirm?: Partial<IConfirmationDialogData>,
  ): Observable<IConfirmationDialogResult> {
    const data = {
      ...confirm,
      header: translate(
        confirm?.header ?? 'i18n.Common.Confirm.Default.Header',
      ),
      message: translate(
        confirm?.message ?? 'i18n.Common.Confirm.Default.Message',
        confirm?.messageInterpolateParams,
      ),
      acceptLabel: translate(confirm?.acceptLabel ?? 'i18n.Common.Button.Ok'),
      rejectLabel: translate(
        confirm?.rejectLabel ?? 'i18n.Common.Button.Cancel',
      ),
      disableBackdropClick: confirm?.disableBackdropClick ?? false,
    } satisfies IConfirmationDialogData;

    const dialogRef = this.dialog.open<
      ConfirmationDialogComponent,
      IConfirmationDialogData,
      IConfirmationDialogResult
    >(ConfirmationDialogComponent, { data: data });

    return dialogRef.afterClosed().pipe(
      map(
        (r) =>
          ({
            accepted: r?.accepted ?? false,
          }) satisfies IConfirmationDialogResult,
      ),
    );
  }
}
